const getItemServices = services => services.filter(service => !service.trip && !service.segment);

export default getItemServices;
